const normalize = (refObj: any | Array<any>) => {
    if (refObj) {
        return JSON.parse(JSON.stringify(refObj))
    }
    return {}
}

const normalizeArray = (refArr: Array<any>) => {
    if (refArr) {
        return JSON.parse(JSON.stringify(refArr)) as any[]
    }
    return []
}

export { normalize, normalizeArray }